<template>
  <div>
    Admin HOME
  </div>
</template>

<script>
export default {
  name: 'Home',
  data: () => ({
  }),
  methods: {
  },
};
</script>

<style>

</style>
